/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoSearchSelect implements angular.IDirective {
        private itemsPerPage: number = 25;

        restrict = "E";
        scope = {
            itemTemplateUrl: "@",
            baseEndpoint: "@"
        }

        templateUrl = "app/components/controls/searchSelectTemplate.html";

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            scope.searchText = '';
            scope.container = null;
            scope.selected = [];
            scope.criteria = { includeActive: true };

            /* START: Infinite Scroll Data Retrieval */

            scope.items = new Meevo.Components.BaseClasses.PagedResults(this.dataService, scope.baseEndpoint);
            scope.search = (): void => {
                let request = {
                    pageNumber: 1,
                    itemsPerPage: this.itemsPerPage,
                    filter: scope.searchText,
                    criteria: null,
                    sortBy: '',
                    sortDirection: Model.SortDirection.Ascending,
                    includeActive: scope.criteria.includeActive,
                    includeDeleted: scope.criteria.includeDeleted,
                    includeInactive: scope.criteria.includeInactive
                }

                scope.items.initSearch(request);
            }

            /* END: Infinite Scroll Data Retrieval */


            scope.addToSelected = (item): void => {
                scope.selected.push(item);
            }
            var elements = element.find('div');
            for (var i = 0; i < elements.length; i++) {
                if (angular.element(elements[i]).hasClass('virtualRepeatdemoInfiniteScroll')){
                    scope.container = angular.element(elements[i]);
                    scope.container.addClass('hidden');
                    break;
                }
            }

            scope.$watch('searchText', searchText => {
                if (searchText != '') {
                    scope.container.addClass('visible');
                    scope.container.removeClass('hidden');

                    scope.search();
                }
                else if (searchText == '') {
                    if (scope.container != null && scope.container.hasClass('visible')) {
                        scope.container.addClass('hidden');
                        scope.container.removeClass('visible');
                    }
                };
            });


        }

        constructor(private $state: angular.ui.IStateService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private loggingService: Meevo.Components.Logging.ILoggingService) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($state: angular.ui.IStateService,
                dataService: Meevo.Components.BaseClasses.IDataService,
                loggingService: Meevo.Components.Logging.ILoggingService) => {
                return new MeevoSearchSelect($state, dataService, loggingService);
            }

            directive.$inject = ["$state", "meevo.components.common.DataService", "meevo.components.logging.LoggingService"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoSearchSelect", MeevoSearchSelect.factory());
}